exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".code-tabs {\n  padding-bottom: 2rem; }\n\n.code-tabs .nav-tabs .nav-link.active {\n  background-color: #f5f7ff;\n  border-bottom-color: #f5f7ff; }\n\n.code-tabs .code-copy {\n  top: 0px; }\n", "", {"version":3,"sources":["/Users/terotikkanen/Projects/open-city-design/src/components/CodeTabs/CodeTabs.scss"],"names":[],"mappings":"AAAA;EACM,qBAAoB,EACzB;;AAED;EACM,0BAAyB;EACzB,6BAA4B,EACjC;;AAED;EACM,SAAQ,EACb","file":"CodeTabs.scss","sourcesContent":[".code-tabs {\n      padding-bottom: 2rem;\n}\n\n.code-tabs .nav-tabs .nav-link.active {\n      background-color: #f5f7ff;\n      border-bottom-color: #f5f7ff;\n}\n\n.code-tabs .code-copy {\n      top: 0px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/CodeTabs/CodeTabs.scss
// module id = 280
// module chunks = 0